// import React from "react";
//
// export interface AlertProps {
//   children?: React.ReactNode;
// }
//
// /** simple placeholder alert box */
// export const Alert: React.FC<AlertProps> = ({ children }) => (
//   <div className="alert">{children}</div>
// );

// import React from "react";
//
// export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {}
//
// export const Alert: React.FC<AlertProps> = ({ className, children, ...props }) => (
//   <div className={className} {...props}>
//     {children}
//   </div>
// );

import React from "react";

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  /** visual style variant */
  variant?: 'info' | 'success' | 'warning' | 'destructive';
}

export const Alert: React.FC<AlertProps> = ({
  variant = 'info',
  className = '',
  children,
  ...props
}) => {
  // minimal placeholder styles—swap in your design tokens as needed
  const variantClasses: Record<string, string> = {
    info: 'bg-blue-50 text-blue-800',
    success: 'bg-green-50 text-green-800',
    warning: 'bg-yellow-50 text-yellow-800',
    destructive: 'bg-red-50 text-red-800',
  };

  const cls = `alert ${variantClasses[variant] || ''} ${className}`.trim();

  return (
    <div className={cls} role="alert" {...props}>
      {children}
    </div>
  );
};